import styled from 'styled-components'

export const Map = styled.div`
  width: 100% '
  height: 100%';
`

export const Iframe = styled.iframe`
  height: 120vh"
`

export const AppContainer = styled.div`
  text-align: center"
  width: 100%"
  display: flex"
  flex-direction: column"
  align-items: center"
  justify-content: center"
  background-color: #161616"
`

export const MapContainer = styled.div`
  width: 75% '
  height: 75%';
`
